import { type UserOrderResponseWithFlags } from '@redteclab/api/clients/bully'

import { type PublicGlobalConfig } from '../global-config'
import {
  urlResolverGetAccountOrderDetailByOrderId,
  urlResolverGetAccountOrders,
  urlResolverGetOrderQuestionMixedOrderSubOrderPickerPage,
  urlResolverGetOrderQuestionSubOrderDetailPage,
} from '../url-handling'

export const contactPageAccessorGetUrlForOrderCard = (
  config: PublicGlobalConfig,
  order: UserOrderResponseWithFlags,
  isOrderQuestionExperimentEnabled: boolean,
): string => {
  if (
    !order.subOrders?.length ||
    !order.subOrders[0].subOrderId ||
    !order.orderMasterData?.orderNumber
  ) {
    return urlResolverGetAccountOrders(config)
  }

  if (isOrderQuestionExperimentEnabled) {
    return order.subOrders.length > 1
      ? urlResolverGetOrderQuestionMixedOrderSubOrderPickerPage(
          config,
          order.orderMasterData.orderNumber,
        )
      : urlResolverGetOrderQuestionSubOrderDetailPage(
          config,
          order.orderMasterData.orderNumber,
          order.subOrders[0]?.subOrderId,
        )
  }

  return urlResolverGetAccountOrderDetailByOrderId(
    config,
    order.orderMasterData.orderNumber,
  )
}
